/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UploadsControllerCreateProjectUploadSessionMutationRequest, UploadsControllerCreateProjectUploadSessionMutationResponse, UploadsControllerCreateProjectUploadSession400, UploadsControllerCreateProjectUploadSession401, UploadsControllerCreateProjectUploadSession403 } from "../../models/uploadsController/UploadsControllerCreateProjectUploadSession";

function getUploadsControllerCreateProjectUploadSessionUrl() {
  const res = { method: 'POST', url: `/api/v1/uploads` as const }  
  return res
}

/**
 * @summary Create upload sessions for files - accepts array of files
 * {@link /api/v1/uploads}
 */
export async function uploadsControllerCreateProjectUploadSession(data?: UploadsControllerCreateProjectUploadSessionMutationRequest, config: Partial<RequestConfig<UploadsControllerCreateProjectUploadSessionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<UploadsControllerCreateProjectUploadSessionMutationResponse, ResponseErrorConfig<UploadsControllerCreateProjectUploadSession400 | UploadsControllerCreateProjectUploadSession401 | UploadsControllerCreateProjectUploadSession403>, UploadsControllerCreateProjectUploadSessionMutationRequest>({ method : "POST", url : getUploadsControllerCreateProjectUploadSessionUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}